import React from 'react';

export default function StainlessSteelCylinderIcon({
  width = 64,
  height = 96,
  startColor = '#1E1E1E',
  midColor = '#D8D8D8',
  endColor = '#1E1E1E'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 75.002 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Layer_4">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="37.4451" y1="98.9863" x2="37.4451" y2="107.207">
		<stop offset="0" style={{stopColor: "#BABABA"}} />
		<stop offset="0.22" style={{stopColor: "#A3A3A3"}} />
		<stop offset="0.68" style={{stopColor: "#676767"}} />
		<stop offset="1" style={{stopColor: "#3A3A3A"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M73.763,98.986H1.127v8.221h72.636V98.986z" />
</g>
<g id="Group1">
	<path fill="#A4A4A4" d="M56.195,103.717h-37.5v8.107h37.5V103.717z" />
</g>
<g id="Group_TankBody">
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="0.0012" y1="56.25" x2="75.0012" y2="56.25">
		<stop offset="0" style={{stopColor: "#373737"}} />
		<stop offset="0.49" style={{stopColor: "#EBEBEB"}} />
		<stop offset="0.56" style={{stopColor: "#D8D8D8"}} />
		<stop offset="0.71" style={{stopColor: "#A7A7A7"}} />
		<stop offset="0.92" style={{stopColor: "#595959"}} />
		<stop offset="1" style={{stopColor: "#373737"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} d="M41.217,0c-1.407,0-4.223,0-5.63,0C3.626,0,0.001,2.14,0.001,2.14v0.113v96.396   c0,0,2.75,4.148,25.788,4.148v9.703h23.424v-9.706c24.55,0,25.788-4.37,25.788-4.37V2.252C75.001,2.252,72.001,0,41.217,0z" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="88.1191" x2="75.0022" y2="88.1191">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} d="M75.002,86.855c0,0-5.669,3.333-37.558,3.333S0,86.855,0,86.855l0.001-0.805   c0,0,5.555,3.604,37.443,3.604s37.557-3.604,37.557-3.604" />
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="77.5898" x2="75.0022" y2="77.5898">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_4_)`} d="M75.002,76.326c0,0-5.669,3.333-37.558,3.333S0,76.326,0,76.326l0.001-0.805   c0,0,5.555,3.604,37.443,3.604s37.557-3.604,37.557-3.604" />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="33.0518" x2="75.0022" y2="33.0518">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_5_)`} d="M75.002,33.012c0,0-5.612,0.885-37.501,0.885S0,33.012,0,33.012l0.001-0.805   c0,0,5.611,0.845,37.5,0.845s37.5-0.845,37.5-0.845" />
	<linearGradient id={`${id}_6_`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="41.8359" x2="75.0022" y2="41.8359">
		<stop offset="0" style={{stopColor: "#1E1E1E"}} />
		<stop offset="0.45" style={{stopColor: "#989898"}} />
		<stop offset="0.62" style={{stopColor: "#858585"}} />
		<stop offset="0.77" style={{stopColor: "#727272"}} />
		<stop offset="1" style={{stopColor: "#1E1E1E"}} />
	</linearGradient>
	<path fill={`url(#${id}_6_)`} d="M75.002,41.796c0,0-5.612,0.885-37.501,0.885S0,41.796,0,41.796l0.001-0.805   c0,0,5.611,0.845,37.5,0.845s37.5-0.845,37.5-0.845" />
</g>
<g id="Group_Label4">
	<path fill="#606060" d="M65.767,6.982V19.82l9.234-0.901V7.883L65.767,6.982z" />
	<path fill="#D8D8D8" d="M67.118,8.221v10.248l7.883-0.675V8.896L67.118,8.221z" />
</g>
<g id="Group_Label3">
	<path fill="#656565" d="M46.848,92.567H28.042v8.108h18.806V92.567z" />
</g>
<g id="Group_Label2">
	<path fill="#FFFFFF" d="M18.695,9.347h37.5v14.64h-37.5V9.347z" />
</g>
<g id="Group_Label1">
	<path fill="#878787" d="M39.191,20.496h15.202v2.252H39.191V20.496z" />
</g>
    
      </g>
      <rect x="0" y="0" width="75.002" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
